import Immutable from 'immutable';
const LOAD = 'timeoffRequests/LOAD';
const LOAD_FAIL = 'timeoffRequests/LOAD_FAIL';
const LOAD_TIMEOFF_LIST = 'timeoffRequests/LOAD_TIMEOFF_LIST';
const LOAD_PAY_TIMEOFF_LIST = 'timeoffRequests/LOAD_PAY_TIMEOFF_LIST';
const LOAD_AVAILABLE_DR_TIMEOFF_LIST = 'timeoffRequests/LOAD_AVAILABLE_DR_TIMEOFF_LIST';
const LOAD_SAVE_FORM = 'timeoffRequests/LOAD_SAVE_FORM';
const CLOSE_ERROR_MESSAGE = 'timeoffRequests/CLOSE_ERROR_MESSAGE';
const LOAD_TIMEOFF_REQUEST_SUCCESS = 'timeoffRequests/LOAD_TIMEOFF_REQUEST_SUCCESS';
const LOAD_TIMEOFF_REQUEST_FAIL = 'timeoffRequests/LOAD_TIMEOFF_REQUEST_FAIL';
const LOAD_DOCTOR_SCHEDULE_SUCCESS = 'timeoffRequests/LOAD_DOCTOR_SCHEDULE_SUCCESS';
const LOAD_DOCTOR_SCHEDULE_FAIL = 'timeoffRequests/LOAD_DOCTOR_SCHEDULE_FAIL';
const LOAD_TIMEOFF_DOC_SUCCESS = "timeoffRequests/LOAD_TIMEOFF_DOC_SUCCESS";
const LOAD_TIMEOFF_DOC_FAIL = "timeoffRequests/LOAD_TIMEOFF_DOC_FAIL";
const LOAD_TIMEOFF_UPDATE_SUCCESS = "timeoffRequests/LOAD_TIMEOFF_UPDATE_SUCCESS";
const LOAD_TIMEOFF_UPDATE_FAIL = "timeoffRequests/LOAD_TIMEOFF_UPDATE_FAIL";
const LOAD_TIMEOFF_GUIDELINES= "timeoffRequests/LOAD_TIMEOFF_GUIDELINES";
const LOAD_TIMEOFF_GUIDELINES_SUCCESS= "timeoffRequests/LOAD_TIMEOFF_GUIDELINES_SUCCESS";
const LOAD_TIMEOFF_GUIDELINES_FAIL= "timeoffRequests/LOAD_TIMEOFF_GUIDELINES_FAIL";

const initialState = Immutable.fromJS({
  isLoad: false,
  loadErr: null,
  timeoffRequestsList:[],
  reportData: [],
  drScheduleDays: {},
  timeoffGuideline:null,
  dbTimeOffDocuments:[],
  payTimeoffRequestList:[]
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case LOAD:
      return state
        .set('isLoad', true)
        .set('loadErr', null);

    case CLOSE_ERROR_MESSAGE:
      return state
        .set('loadErr', null);

    case LOAD_TIMEOFF_LIST:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('timeoffRequestList', action.res);
    case LOAD_PAY_TIMEOFF_LIST:
      return state
          .set('isLoad', false)
          .set('loadErr', null)
          .set('payTimeoffRequestList', action.res);

    case LOAD_AVAILABLE_DR_TIMEOFF_LIST:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('availableDoctorsTimeOff', action.res);

    case LOAD_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('timeoffRequestList', null);

    case LOAD_TIMEOFF_REQUEST_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('reportData', action.res);

    case LOAD_TIMEOFF_REQUEST_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('reportData', []);

    case LOAD_DOCTOR_SCHEDULE_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('drScheduleDays', action.res);

    case LOAD_DOCTOR_SCHEDULE_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('drScheduleDays', null);

    case LOAD_SAVE_FORM:
      return state
        .set('isLoad', false)
        .set('loadErr', null);

    case LOAD_TIMEOFF_DOC_SUCCESS:
      return state
        .set('isLoad', false)
        .set('loadErr', null)
        .set('timeoffGuideline', action.res);
    
    case LOAD_TIMEOFF_DOC_FAIL:
      return state
        .set('isLoad', false)
        .set('loadErr', action.error)
        .set('timeoffGuideline', null);
    case LOAD_TIMEOFF_UPDATE_SUCCESS:
          return state
            .set('isLoad', false)
            .set('loadErr', null)
            .set('timeoffGuideline', action.res);
    
    case LOAD_TIMEOFF_UPDATE_FAIL:
          return state
            .set('isLoad', false)
            .set('loadErr', action.error)
            .set('timeoffGuideline', null);

    case LOAD_TIMEOFF_GUIDELINES:
      return state
      .set('isLoad',true)
      .set('loadErr', null)
      .set('dbTimeOffDocuments',null);
    case LOAD_TIMEOFF_GUIDELINES_SUCCESS:
      return state
      .set('isLoad',false)
      .set('loadErr', null)
      .set('dbTimeOffDocuments',action.res);
    case LOAD_TIMEOFF_GUIDELINES_FAIL:
      return state
      .set('isLoad',false)
      .set('loadErr', action.error)
      .set('dbTimeOffDocuments',null);

    default:
      return state;
  }
};

export const hideErrorModal = () => async (dispatch, getState, api) => {
  dispatch({ type: CLOSE_ERROR_MESSAGE, action: null });
}

export const updateTimeoffRequests = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.put(`/timeOff`, {data: obj});
    dispatch({ type: LOAD_SAVE_FORM, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    return false;
  }
};

export const deleteTimeoffRequests = (deleteIds) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.del(`/timeOff`, { data: {deleteIds: deleteIds} });
    dispatch({ type: LOAD_SAVE_FORM, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    return false;
  }
};

export const getTimeoffRequests = (filters) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get(`/timeOff${(filters?'/'+filters:"")}`);
    dispatch({ type: LOAD_TIMEOFF_LIST, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    return [];
  }
};
export const getPayTimeoffRequests = (id) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get('/timeOff/getDoctorPayTimeOffList/'+id);
    dispatch({ type: LOAD_PAY_TIMEOFF_LIST, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    return [];
  }
};

export const unscheduledDoctorsList = (params) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get('/timeOff/getUnscheduledDoctors', {params});
    dispatch({ type: LOAD_TIMEOFF_LIST, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    return [];
  }
};

export const getAvailableDoctorsTimeOff = (params) => async (dispatch, getState, api) => {

  dispatch({ type: LOAD });
  try {
    let res = await api.get('/timeOff/getAvailableDoctorsTimeOff', {params});
    dispatch({ type: LOAD_AVAILABLE_DR_TIMEOFF_LIST, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    return [];
  }
};

export const getOdUser = (params) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get('/timeOff/getOdUser', {params});
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    return [];
  }
};

export const getOdAbbr = (params) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get('/timeOff/getOdAbbr', {params});
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    return [];
  }
};

export const updateDays = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.put(`/timeOff/updateTimeOffDays`, {data: obj});
    dispatch({ type: LOAD_SAVE_FORM, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    return false;
  }
};
export const updatePayTimeOffDays = (obj) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.put(`/timeOff/updateDoctorPayTimeOffDays`, {data: obj});
    dispatch({ type: LOAD_SAVE_FORM, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_FAIL, error: err.message });
    return false;
  }
};

export const getTimeoffRequestReport = (params='') => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get(`reports/api/timeoffRequests/${params}`);
    dispatch({ type: LOAD_TIMEOFF_REQUEST_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_TIMEOFF_REQUEST_FAIL, error: err.message });
  }
};

export const getDoctorScheduleDays = (params='') => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
    let res = await api.get(`reports/api/getDoctorScheduleDays/${params}`);
    dispatch({ type: LOAD_DOCTOR_SCHEDULE_SUCCESS, res: res });
    return res;
  } catch (err) {
    dispatch({ type: LOAD_DOCTOR_SCHEDULE_FAIL, error: err.message });
  }
};

export const sendTimeOffGuideline = (details) => async (dispatch, getState, api) => {
  try {
      let res = await api.post('/timeOff/sendTimeOffGuidelines',{ data: details });
      alert('Sent');
      return res;
  } catch (err) {
      dispatch({ type: LOAD, error: err.message });
  }
};

export const uploadTimeOffGuideline = (details) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
      let res = await api.post('/timeOff/uploadTimeOffGuideline',{ data: details });
      dispatch({type:LOAD_TIMEOFF_DOC_SUCCESS , res:res})
      return res;
  } catch (err) {
      dispatch({type:LOAD_TIMEOFF_DOC_FAIL, error:err.message})
  }
}

export const updateTimeOffGuideline = (details) => async (dispatch, getState, api) => {
  dispatch({ type: LOAD });
  try {
      let res = await api.post('/timeOff/updateTimeOffGuideline',{ data: details });
      dispatch({type:LOAD_TIMEOFF_UPDATE_SUCCESS , res:res})
      return res;
  } catch (err) {
      dispatch({type:LOAD_TIMEOFF_UPDATE_FAIL, error:err.message})
  }
}

export const getTimeOffDocuments = () => async (dispatch, getState, api) =>{
  dispatch({ type: LOAD_TIMEOFF_GUIDELINES });
  try {
   let res =  await api.get('/timeOff/getTimeOffGuideline'); 
    dispatch({ type:LOAD_TIMEOFF_GUIDELINES_SUCCESS, res: res});
    return res;
  } catch (error) {
      dispatch({ type: LOAD_TIMEOFF_GUIDELINES_FAIL, error: error.message});
  }
}
